import React from "react";
import { Trans } from "react-i18next";

type Props = { error_key: string };

const ValidationError = (props: Props) => {
  return (
    <div className={"errorMessage"} id={props.error_key}>
      {props.error_key && <Trans i18nKey={`error.${props.error_key}`}></Trans>}
    </div>
  );
};

export default ValidationError;
